export default "__VITE_ASSET__Bel4fGOb__"